export const API_URL = process.env.REACT_APP_API_URL;
export const ADMIN_SERVER = process.env.REACT_APP_SERVER;
export const ASSETS_SERVER = process.env.REACT_APP_ASSETS;

export default API_URL;